<template>
  <div class="item-card-container" :data-testid="'item-card-' + item.id" :class="{ 'top-group-pick': isTopGroupPick }">
    <div v-if="isTopGroupPick" class="group-pick-label">
      <span><i class="fas fa-trophy mr-1" aria-hidden="true"></i>Current group choice</span>
      <small v-if="formattedAverageRank">Average rank: {{ formattedAverageRank }}</small>
    </div>
    <router-link
      :to="'/items/' + item.id + '?listId=' + listId"
      class="item-card item-card-action"
      :class="{ 'has-watched-action': canMarkWatched }">
      <img class="mx-auto mb-lg-0 mb-3" :src="item.poster" alt="" />
      <div class="movie-item-body mb-sm-0 mb-3">
        <div class="flex">
          <h2 class="mb-1">
            {{ item.title }}
            <small class="year">({{ item.year }})</small>
          </h2>
        </div>
        <p class="mb-1 d-none d-sm-block">{{ item.plot }}</p>
        <p class="mb-1 d-block d-sm-none">{{ truncateText(100) }}</p>
        <div class="movie-ratings">
          <small v-for="rating in item.itemRatings" :key="rating.id">
            <b>{{ rating.ratingSource.ratingName }}</b>
            :
            <span>{{ rating.ratingValue }}</span>
            <span class="d-none d-md-inline">•</span>
            <div class="d-inline d-md-none"><br /></div>
          </small>
        </div>
      </div>
      <small class="date text-muted">{{ datePrefix }} {{ timeAgo }}</small>
    </router-link>
    <button
      v-if="canMarkWatched"
      class="btn btn-yellow mark-watched"
      :data-testid="'mark-watched-' + item.id"
      type="button"
      :disabled="markingWatched"
      @click="$emit('mark-watched')">
      <i class="fas fa-check mr-1" aria-hidden="true"></i>
      {{ markingWatched ? "Marking..." : "Mark as watched" }}
    </button>
    <button
      v-if="canRestore"
      class="btn btn-link restore-active"
      :data-testid="'restore-active-' + item.id"
      type="button"
      :disabled="restoring"
      @click="$emit('restore-active')">
      {{ restoring ? "Returning..." : "Return to active list" }}
    </button>
  </div>
</template>

<script>
import TimeAgo from "../utilities/TimeAgo";

export default {
  name: "ItemCardLarge",
  props: {
    item: Object,
    listId: Number,
    dateAdded: String,
    datePrefix: {
      type: String,
      default: "added"
    },
    canMarkWatched: {
      type: Boolean,
      default: false
    },
    markingWatched: {
      type: Boolean,
      default: false
    },
    canRestore: {
      type: Boolean,
      default: false
    },
    restoring: {
      type: Boolean,
      default: false
    },
    isTopGroupPick: {
      type: Boolean,
      default: false
    },
    averageRank: {
      type: [Number, String],
      default: null
    }
  },
  emits: ["mark-watched", "restore-active"],
  computed: {
    timeAgo() {
      return TimeAgo(this.dateAdded);
    },
    formattedAverageRank() {
      const averageRank = Number(this.averageRank);

      return Number.isFinite(averageRank) ? averageRank.toFixed(1) : null;
    }
  },
  methods: {
    truncateText(num) {
      if (this.item.plot.length > num) {
        let subString = this.item.plot.slice(0, num);
        return subString.substr(0, Math.min(subString.length, subString.lastIndexOf(" "))) + "...";
      } else {
        return this.item.plot;
      }
    }
  }
};
</script>

<style scoped>
.item-card-container {
  position: relative;
}

.group-pick-label {
  align-items: center;
  background-color: #e8c547;
  color: #393d55;
  display: flex;
  font-weight: bold;
  justify-content: space-between;
  margin: 20px 10px -20px;
  padding: 0.45rem 1rem;
}

.group-pick-label small {
  color: #393d55;
  font-weight: bold;
}

.top-group-pick .item-card {
  border-color: #e8c547 !important;
}

.movie-item-body {
  margin-left: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.movie-ratings {
  margin-top: auto;
  margin-bottom: 5px;
}

.movie-ratings small b {
  color: #e8c547 !important;
}

.mark-watched {
  bottom: 1.75rem;
  position: absolute;
  right: 2rem;
  z-index: 1;
}

.mark-watched:disabled {
  cursor: wait;
}

.restore-active {
  color: #e8c547;
  display: block;
  margin: -1rem 10px 1rem auto;
  padding: 0.25rem 0.5rem;
}

.restore-active:disabled {
  color: #c7cad8;
  cursor: wait;
}

.has-watched-action .movie-item-body {
  padding-right: 11rem;
}

/* Small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) {
  .group-pick-label {
    align-items: flex-start;
    flex-direction: column;
  }

  .item-card small.date {
    left: 20px;
    bottom: 10px;
  }

  .mark-watched {
    bottom: 1.75rem;
    left: 2rem;
    right: auto;
  }

  .has-watched-action {
    padding-bottom: 4.5rem;
  }

  .has-watched-action .movie-item-body {
    padding-right: 0;
  }
}
</style>
